<div *ngIf="userState" class="container-user-state" [class]="userType">
  <ng-container *ngIf="userState.state === 'USER_LEFT'">
    <div class="state-left-title">L'utilisateur s'est déconnecté !</div>
    <div class="user-state-description">Dans {{ userState.countdown }} secondes, la visio se fermera.</div>
  </ng-container>
  <ng-container *ngIf="userState.state === 'USER_DISCONNECTING'">
    <div class="state-left-title">Fin de la visio avec le proche!</div>
  </ng-container>
  <ng-container *ngIf="userState.state === 'USER_RECONNECTING'">
    <div class="state-reconnecting-title animate-pulse">L'utilisateur est entrain de se connecter...</div>
  </ng-container>

  <ng-container *ngIf="userState.state === 'CONFERENCE_JOINING'">
    <div class="state-left-title">Veuillez patienter pendant que votre proche rejoint l'appel video...</div>
  </ng-container>

  <ng-container *ngIf="userState.state === 'DEVICE_IN_USE'">
    <div class="state-left-title">Votre caméra n'est pas disponible...</div>
    <div class="user-state-description mb-2">Votre caméra est actuellement en cours d'utilisation par une autre application.
      <br> Veuillez fermer l'application en question, puis actualisez cette page pour réessayer.
    </div>
    <button mat-flat-button
            class="size-xl"
            color="accent"
            type="button" (click)="window.location.reload()">
      Recharger la page
    </button>
  </ng-container>

  <ng-container *ngIf="userState.state === 'CAMERA_ACCESS_DENIED'">
    <div class="state-left-title">Accès à la caméra refusé !</div>
    <div class="user-state-description mb-2">Vous avez refusé l’accès à votre caméra dans les paramètres de votre navigateur. Sans cette autorisation, la visioconférence ne peut pas fonctionner.
      <br> Veuillez accorder l’accès à la caméra dans les paramètres de votre navigateur, puis rafraîchissez la page pour appliquer les modifications.
    </div>
    <div class="user-state-help mb-2">Google Chrome : Cliquez sur l’icône 🔒 à gauche de la barre d’adresse, puis activez Caméra.
      <br> Firefox: Allez dans <span>Paramètres</span> → <span>Vie privée et sécurité</span> → <span>Permissions</span>, puis autorisez la caméra.
      <br> Safari : Accédez à <span>Réglages du site Web</span> → <span>Caméra</span>, puis sélectionnez Autoriser.
    </div>
    <button mat-flat-button
            class="size-xl"
            color="accent"
            type="button" (click)="window.location.reload()">
      Recharger la page
    </button>
  </ng-container>
</div>
